import { Controller } from "stimulus"

// Toggle visibility of content sections.
//
// Usage (basic show/hide):
//   .div{"data-controller" => "toggle"}
//     %button{"data-action" => "click->toggle#toggle"} Show/Hide
//     .div{"data-toggle-target" => "content", class: "d-none"}
//       Content here
//
// Usage (with custom CSS class):
//   .div{"data-controller" => "toggle", "data-toggle-class-value" => "visually-hidden"}
//     %button{"data-action" => "click->toggle#toggle"} Toggle
//     .div{"data-toggle-target" => "content"}
//       Content here
//
// Usage (label swaps "SEE MORE"/"SEE LESS" when both label values are given, optional):
//   .div{"data-controller" => "toggle", "data-toggle-label-collapsed-value" => "SEE MORE", "data-toggle-label-expanded-value" => "SEE LESS"}
//     %button{"data-action" => "click->toggle#toggle"}
//       %span{"data-toggle-target" => "label"} SEE MORE
//
export default class extends Controller {
  static targets = ["content", "icon", "label"]
  // { type, default } shorthand throws on this app's Stimulus version and aborts controller loading site-wide -- bare type + manual fallback instead
  static values = {
    class: String,
    labelCollapsed: String,
    labelExpanded: String
  }

  toggle() {
    var klass = this.hasClassValue ? this.classValue : "d-none"
    this.contentTargets.forEach(function(el) {
      el.classList.toggle(klass)
    })

    // Rotate icon if present (e.g. chevron)
    this.iconTargets.forEach(function(el) {
      el.classList.toggle("fa-rotate-180")
    })

    // Swap the trigger's label text, if both label values were given.
    if (this.hasLabelCollapsedValue && this.hasLabelExpandedValue) {
      var stillCollapsed = this.contentTargets.length > 0 && this.contentTargets[0].classList.contains(klass)
      var newText = stillCollapsed ? this.labelCollapsedValue : this.labelExpandedValue
      this.labelTargets.forEach(function(el) {
        el.textContent = newText
      })
    }
  }

  show() {
    var klass = this.hasClassValue ? this.classValue : "d-none"
    this.contentTargets.forEach(function(el) {
      el.classList.remove(klass)
    })
  }

  hide() {
    var klass = this.hasClassValue ? this.classValue : "d-none"
    this.contentTargets.forEach(function(el) {
      el.classList.add(klass)
    })
  }
}
